import React from "react";
import "./SpiraDots.css";
const SpiralDots = () => {
  const N = 600;
  const SIZE = 400;
  const DOT_RADIUS = 2;
  const MARGIN = 2;
  const DURATION = 3;
  const GOLDEN_ANGLE = Math.PI * (3 - Math.sqrt(5));
  const CENTER = SIZE / 2;
  const MAX_RADIUS = CENTER - MARGIN - DOT_RADIUS;
  const dots = [];
  for (let i = 0; i < N; i++) {
    const idx = i + 0.5;
    const frac = idx / N;
    const r = Math.sqrt(frac) * MAX_RADIUS;
    const theta = idx * GOLDEN_ANGLE;
    const x = CENTER + r * Math.cos(theta);
    const y = CENTER + r * Math.sin(theta);
    dots.push(
      <circle key={i} cx={x} cy={y} r={DOT_RADIUS} fill="#fff" opacity="0.6">
        <animate attributeName="r" values={`${DOT_RADIUS * 0.5};${DOT_RADIUS * 1.5};${DOT_RADIUS * 0.5}`} dur={`${DURATION}s`} begin={`${frac * DURATION}s`} repeatCount="indefinite" calcMode="spline" keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
        <animate attributeName="opacity" values="0.3;1;0.3" dur={`${DURATION}s`} begin={`${frac * DURATION}s`} repeatCount="indefinite" calcMode="spline" keySplines="0.4 0 0.6 1;0.4 0 0.6 1" />
      </circle>
    );
  }
  return (
    <div style={{ width: "100%", height: SIZE, display: "flex", alignItems: "center", justifyContent: "center", background: "#000" }}>
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>{dots}</svg>
    </div>
  );
};

export default SpiralDots;